import React, { useState } from "react";
import QRCode from "react-qr-code";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Spinner, Button } from 'react-bootstrap';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import {MdDownload} from 'react-icons/md'
import { findByReferralCode } from './../../../../../store/actions'
import toast from 'react-hot-toast';

const options = {
  // default is `save`
  method: 'save',
  // default is Resolution.MEDIUM = 3, which should be enough, higher values
  // increases the image quality but also the size of the PDF, so be careful
  // using values higher than 10 when having multiple pages generated, it
  // might cause the page to crash or hang.
  resolution: Resolution.HIGH,
  page: {
    // margin is in MM, default is Margin.NONE = 0
    margin: Margin.SMALL,
    // default is 'A4'
    format: 'letter',
    // default is 'portrait'
    orientation: 'portrait',
  },
  canvas: {
    // default is 'image/jpeg' for better size performance
    mimeType: 'image/png',
    qualityRatio: 1
  },
  // Customize any value passed to the jsPDF instance and html2canvas
  // function. You probably will not need this and things can break, 
  // so use with caution.
  overrides: {
    // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
    pdf: {
      compress: true
    },
    // see https://html2canvas.hertzen.com/configuration for more options
    canvas: {
      useCORS: true
    }
  },
};
class Index extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      bannerMobile: 'https://cdn.sigmobi.com/lpimg/banner_150x150.png',
      bannerDesktop: 'https://cdn.sigmobi.com/lpimg/banner_1024x160.jpeg',
      name: 'Linkt',
      phone: '(38) 93672-3091',
      link: 'https://sigmobioficial.com/',
      code: 'Linkt-sigmobi',
      logo: 'https://cdn.sigmobi.com/lpimg/ic_logo_top_flyer.png',
      url_invicti_qr: 'https://sigmobioficial.com/',
      generate: false,
      showBtnDownload: true
    }

    this.imageUrlToBase64 = this.imageUrlToBase64.bind(this)

  }

  componentDidMount() {
    const { code, generate } = this.props.match.params

    if (code) {
      this.setState({ code: code, generate: generate });
      this.props.findByReferralCode(code);
    } else {
      this.props.findByReferralCode(this.state.code);
    }
   
    this.imageUrlToBase64(this.state.bannerMobile)
    .then((i) => {
      this.setState({ bannerMobile: i});
    })

    this.imageUrlToBase64(this.state.bannerDesktop)
    .then((i) => {
      this.setState({ bannerDesktop: i});
    })

    this.imageUrlToBase64(this.state.logo)
    .then((i) => {
      this.setState({ logo: i});
    })
  }


  imageUrlToBase64 = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
      reader.onerror = reject;
    });
  };

  render() {
    const {
      bannerDesktop,
      bannerMobile,
      link,
      code,
      url_invicti_qr,
      logo,
      generate
    } = this.state

    const getTargetElement = () => document.getElementById("content-id");
    const downloadPdf = () => {
      toast.promise(
        generatePDF(getTargetElement, options),
         {
           loading: () => {
            this.setState({showBtnDownload: false})
            return <b>Gerando Panfleto ...</b>
           },
           success: () => {
            this.setState({showBtnDownload: true})
            return  <b>Panfleto gerado!</b>
           },
           error: () => {
            this.setState({showBtnDownload: true})
            return <b>Ops! Ocorreu um erro ao tentar gerar o Panfleto. Já estamos corrigindo.</b>
           }
         },{
          position: "bottom-center",
         }
       );
    };

    return (
      <>
        { generate && 
          <div className="btn-container">
            <Button 
              className="btn-large" 
              onClick={downloadPdf}
              disabled={!this.state.showBtnDownload}
            >
              <MdDownload/> Download Panfleto
            </Button>
          </div>        
        }
        <div id="content-id" className="container flyer">
          {
            this.props.loading ?
              <Spinner className="text-center" animation="border" role="status" variant="primary">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              :
              <>
                <div className="hstack gap-4">
                  <div>
                    <img
                      src={logo}
                      className="img-fluid banner_top rounded"
                      alt="banner sig"
                    />
                  </div>
                  <div>
                    <img
                      src={bannerDesktop}
                      className="img-fluid banner_top rounded banner"
                      alt="banner sig"
                    />
                    <img
                      src={bannerMobile}
                      className="img-fluid banner_top rounded bannerMobile"
                      alt="banner sig"
                    />
                  </div>
                </div>

                <div className="container content">
                  <h1>A Revolução dos Aplicativos:</h1>
                  <ul>
                    <li>Vantagens para Passageiros</li>
                    <li>Diferenciais para Motoristas</li>
                    <li>Benefícios para ONGs</li>
                  </ul>

                  <strong>Na Sig Mobi Todos Ganham!</strong>
                </div>

                <div className="qr-code-table">
                  <div className="left">
                    <div className="download" >
                      <a href={link}>Baixe o App Através do QR Code e Saiba Mais! </a>
                    </div>
                    <div className="data">
                      <span> Nome: <b></b></span>
                      <span> Fone: <b></b></span>
                    </div>
                  </div>
                  <div className="right">
                    <QRCode
                      size={256}
                      style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                      value={url_invicti_qr.concat(code)}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                </div>
              </>
          }

        </div>
      </>
    )
  }


}

Index.PropTypes = {
  t: PropTypes.any,
  history: PropTypes.any,
  loading: PropTypes.any,
  error: PropTypes.any,
  message: PropTypes.any,
  findByReferralCode: PropTypes.func,
  data: PropTypes.any,
  codigoReferencia: PropTypes.any,
  phone: PropTypes.any

}
const mapStateToProps = state => {
  const {
    data, loading
  } = state.LedgerProfile
  return {
    data, loading
  }
}
export default withTranslation()(withRouter(connect(mapStateToProps, {
  findByReferralCode
})(
  (Index)
)))


/*
const Main = props => {
  const getBanner = (size = '150x150') => `https://placehold.jp/4d58ff/ffffff/${size}.png`
  const [name] = useState(props.name ? props.name : 'Linkt');
  const [phone] = useState(props.phone ? props.phone : '(38) 93672-3091');
  const [link] = useState('#');
  const [url_invicti_qr] = useState("https://sigmobioficial.com/invitation/".concat(props.codigo ? props.codigo : 'Linkt-sigmobi'));
  const [logo] = useState('https://cdn.sigmobi.com/lpimg/ic_logo_top_flyer.png')
  const [bannerDesktop] = useState(getBanner('1024x160')) //'1648x160'
  const [bannerMobile] = useState(getBanner('150x150'))
  const [codigo] = useState(props.codigo);

  return (
    <div className="container flyer">
      <div className="hstack gap-4">
        <div>
          <img
            src={logo}
            className="img-fluid banner_top rounded"
            alt="banner sig"
          />
        </div>
        <div>
          <img
            src={bannerDesktop}
            className="img-fluid banner_top rounded banner"
            alt="banner sig"
          />
          <img
            src={bannerMobile}
            className="img-fluid banner_top rounded bannerMobile"
            alt="banner sig"
          />
        </div>
      </div>

      <div className="container content">
        <h1>A Revolução dos Aplicativos:</h1>
        <ul>
          <li>Vantagens para Passageiros</li>
          <li>Diferenciais para Motoristas</li>
          <li>Benefícios para ONGs</li>
        </ul>

        <strong>Na Sig Mobi Todos Ganham!</strong>
      </div>

      <div className="qr-code-table">
        <div className="left">
          <div className="download" >
            <a href={link}>Baixe o App Através do QR Code e Saiba Mais! </a>
          </div>
          <div className="data">
            <span> Nome: <b>{name}</b></span>
            <span> Fone: <b>{phone}</b></span>
          </div>
        </div>
        <div className="right">
          <QRCode
            size={256}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={url_invicti_qr}
            viewBox={`0 0 256 256`}
          />
        </div>
      </div>
    </div>
  );
};

export default Main;*/
